import { render, staticRenderFns } from "./Corp_List.vue?vue&type=template&id=29f60478"
import script from "./Corp_List.vue?vue&type=script&lang=js"
export * from "./Corp_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports